<div class="drawer-link-group" *ngIf="groupData">
    <finder-component-header
        [data]="groupData"
    ></finder-component-header>
    <div class="drawer-links">
        <finder-campaign-drawer-link
            *ngFor="let drawer of groupData.drawerGroup"
            [drawerData]="drawer.data"
            [linkId]="drawer.linkId">
        </finder-campaign-drawer-link>
    </div>
</div>
